import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setChatlistOpen, setChatlistOpenHover } from '../../Store/Actions/chatlistActions';
import { List, PushPin, X } from '@phosphor-icons/react';
import { RootState } from '../../Store/Reducers';

export default function ChatListToggleButton() {
    const chatlistOpen = useSelector((state: RootState) => state.chatlist.chatlistOpen);
    const chatlistOpenHover = useSelector((state: RootState) => state.chatlist.chatlistOpenHover);
    const dispatch = useDispatch();
    return (
        <>
            <button
                onClick={() => {
                    dispatch(setChatlistOpen(!chatlistOpen));
                    localStorage.setItem('chatlistOpen', (!chatlistOpen).toString());
                }}
                onMouseEnter={() => dispatch(setChatlistOpenHover(true))}
                className={`hidden xl:flex fixed z-[99] left-6 top-6 h-[50px] w-[50px] rounded-full flex justify-center items-center transition-all duration-[300ms] cursor-pointer ${
                    chatlistOpen
                        ? 'bg-chatlist-hoverButton-background-active text-chatlist-hoverButton-text-active'
                        : 'bg-chatlist-hoverButton-background text-chatlist-hoverButton-text hover:bg-chatlist-hoverButton-background-hover'
                }`}
            >
                {chatlistOpenHover && !chatlistOpen ? (
                    <PushPin size={24} />
                ) : chatlistOpen ? (
                    <X size={24} />
                ) : (
                    <List size={24} />
                )}
            </button>
        </>
    );
}
